// extracted by mini-css-extract-plugin
export var badge = "styles-module--badge--8ac63";
export var badgeIcon = "styles-module--badgeIcon--af5b1";
export var iframeContainer = "styles-module--iframeContainer--da94a";
export var payBtnInner = "styles-module--payBtnInner--f5649";
export var playBtn = "styles-module--playBtn--1ce89";
export var playIcon = "styles-module--playIcon--2e32e";
export var portraitVideo = "styles-module--portraitVideo--ce67d";
export var poster = "styles-module--poster--1e33d";
export var video = "styles-module--video--b5b13";
export var videoContainer = "styles-module--video-container--c38d7";